<div class="h-full overflow-auto flex flex-col">
  <div class="flex justify-end p-3 border-b">
    <button wunButton primary (click)="openCreateModal()">+ Crea utente</button>
  </div>
  <div class="h-full overflow-auto">
    <table>
      <thead class="sticky top-0 bg-gray-200 shadow">
      <tr>
        <th>Email</th>
        <th>Nome & cognome</th>
        <th>Stato</th>
        <th>Data registrazione </th>
        @if(role() === 'gallery') {
          <th>Codice Galleria</th>
        }
        @if (role() === 'artists') {
          <th>Galleria di riferimento</th>
        }
        <th>CV</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (row of users.value()?.data; track row.id + 'ROW_' + $index) {
          <tr [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
            <td>{{ row.email }}</td>
            <td>{{ row.firstName }} {{ row.lastName }}</td>
            <td>{{ row.status }}</td>
            <td>{{ row.createdAt | date : 'dd-MM-yyy' }}</td>
            @if(role() === 'gallery') {
              <td>{{ row.gallerySignCode }}</td>
            }
            @if (role() === 'artists') {
              <td>{{ row.assignedToGallery }}</td>
            }
            <td>
              @if (row.cv) {
                <button wunButton (click)="openCV(row.cv.id)">Visualizza CV</button>
              } @else {
                <span class="text-gray-400">N/D</span>
              }
            </td>
            <td class="flex gap-4">
              <button wunButton danger (click)="showDeleteModal.set(true);selectedUser.set(row)">Rimuovi</button>
              @if (role() === 'artists' || role() === 'gallery') {
                <a wunButton [routerLink]="['..', row.id, 'details', 'artworks']">Opere</a>
              }
              <a wunButton primary [routerLink]="['..', row.id, 'details']">Gestisci</a>
            </td>
          </tr>
        }
      </tbody>

    </table>

  </div>
</div>

<cms-modal [(show)]="showDeleteModal">
  <div class="flex justify-center">
    <div class="p-6 bg-white flex flex-col gap-3 rounded-sm">
      <div class="text-xl font-bold">Elimina utente {{selectedUser()?.email}}</div>
      <div>
        Attenzione!
        Se cancelli l'utente tutti i suoi dati, comprese le opere, non saranno piú visibili. <br/> I dati relativi alle transazioni e le opere vendute verranno conservati
      </div>
      <div class="flex gap-3 justify-end">
        <button wunButton danger (click)="deleteUser()">Elimina</button>

        <button wunButton primary (click)="cancelDelete()">Annulla</button>
      </div>
    </div>
  </div>
</cms-modal>

<cms-modal [(show)]="showCreateModal">
  <div class="flex justify-center">
    <div class="p-6 bg-white flex flex-col gap-4 rounded-sm w-[560px]" [formGroup]="createForm">
      <div class="text-xl font-bold">Crea nuovo utente</div>

      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Nome *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="firstName" placeholder="Mario">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Cognome *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="lastName" placeholder="Rossi">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Email *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" type="email" formControlName="email" placeholder="mario@example.com">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Username *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="username" placeholder="mario.rossi">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Password *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" type="password" formControlName="password" placeholder="••••••••">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Telefono *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="phone" placeholder="+39 333 1234567">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Paese *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="country" placeholder="Italia">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Città *</label>
          <input class="border border-gray-300 px-3 py-2 rounded-sm text-sm" formControlName="city" placeholder="Roma">
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Tipo profilo *</label>
          <select class="border border-gray-300 px-3 py-2 rounded-sm text-sm bg-white" formControlName="profileType">
            <option value="ADMIN">Admin</option>
            <option value="ARTIST">Artista</option>
            <option value="COLLECTOR">Collezionista</option>
            <option value="GALLERY">Galleria</option>
          </select>
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Stato *</label>
          <select class="border border-gray-300 px-3 py-2 rounded-sm text-sm bg-white" formControlName="status">
            <option value="ACTIVE">Attivo</option>
            <option value="PENDING">In attesa</option>
            <option value="DISABLED">Disabilitato</option>
          </select>
        </div>
      </div>

      @if (createError()) {
        <div class="text-red-600 text-sm">{{ createError() }}</div>
      }

      <div class="flex gap-3 justify-end pt-2">
        <button wunButton (click)="showCreateModal.set(false)">Annulla</button>
        <button wunButton primary (click)="submitCreateUser()" [disabled]="createSubmitting()">
          {{ createSubmitting() ? 'Creazione...' : 'Crea utente' }}
        </button>
      </div>
    </div>
  </div>
</cms-modal>
